<div class="bg-spinner" *ngIf="display && backdrop">
    <div class="center-spinner">
        <div class="circle"></div>
        <div class="logo"></div>

    </div>
</div>

<div *ngIf="display && !backdrop">
    <div class="circle"></div>
    <div class="logo"></div>
</div>